import { render, staticRenderFns } from "./study-session-calendar.vue?vue&type=template&id=c520cf92&scoped=true&"
import script from "./study-session-calendar.vue?vue&type=script&lang=ts&"
export * from "./study-session-calendar.vue?vue&type=script&lang=ts&"
import style0 from "./study-session-calendar.vue?vue&type=style&index=0&id=c520cf92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c520cf92",
  null
  
)

export default component.exports